import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { get } from 'lodash';

import dataFetcher from 'Parts/chore/dataFetcher';
import { searchPlatformMembersTransactions, clearSearch } from '../../../search/searchActions';

import DonationsList from './DonationsList';

const mapStateToProps = state => ({
  platformId: get(state, 'platform.platform.id'),
  platform: get(state, 'platform.platform'),
  memberId: get(state, 'member.member.id'),
  transactions: get(state, 'search.memberTransactions.results', []),
  pagination: get(state, 'search.memberTransactions.pagination', {}),
  filters: get(state, 'search.memberTransactions.filterBy'),
  search: get(state, 'search.memberTransactions.search'),
  orderBy: get(state, 'search.memberTransactions.orderBy'),
  locale: get(state, 'session.language'),
  organization: get(state, 'organization.organization')
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchPlatformMembersTransactions,
  clearSearch
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  dataFetcher
)(DonationsList);
